export default __webpack_public_path__ + "static/media/Spill Trays.1a286e1b.jpg";